/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  ProgramTypeRef,
  ProgramTypeRefOptional,
  ProgramTypeRefMetaI,
  ProgramTypeRefTrackedI,
} from "./program-type-ref";
import { ProgramTypeRefTracked, ProgramTypeRefMeta } from "./program-type-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassInstanceRef,
  UnifiedClassInstanceRefOptional,
  UnifiedClassInstanceRefMetaI,
  UnifiedClassInstanceRefTrackedI,
} from "./unified-class-instance-ref";
import {
  UnifiedClassInstanceRefTracked,
  UnifiedClassInstanceRefMeta,
} from "./unified-class-instance-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassSignupRef,
  UnifiedClassSignupRefOptional,
  UnifiedClassSignupRefMetaI,
  UnifiedClassSignupRefTrackedI,
} from "./unified-class-signup-ref";
import {
  UnifiedClassSignupRefTracked,
  UnifiedClassSignupRefMeta,
} from "./unified-class-signup-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassTypeRef,
  UnifiedClassTypeRefOptional,
  UnifiedClassTypeRefMetaI,
  UnifiedClassTypeRefTrackedI,
} from "./unified-class-type-ref";
import {
  UnifiedClassTypeRefTracked,
  UnifiedClassTypeRefMeta,
} from "./unified-class-type-ref";

/**
 *
 * @export
 * @interface ClassFilterOptions
 */
export interface ClassFilterOptionsOptional {
  /**
   *
   * @type {boolean}
   * @memberof ClassFilterOptions
   */
  includeAvailability?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassFilterOptions
   */
  includeCancelled?: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassFilterOptions
   */
  startDate?: Date;
  /**
   *
   * @type {string}
   * @memberof ClassFilterOptions
   */
  endDate?: Date;
  /**
   *
   * @type {UnifiedClassTypeRef}
   * @memberof ClassFilterOptions
   */
  typeId?: UnifiedClassTypeRefOptional;
  /**
   *
   * @type {ProgramTypeRef}
   * @memberof ClassFilterOptions
   */
  programId?: ProgramTypeRefOptional;
  /**
   *
   * @type {UnifiedClassInstanceRef}
   * @memberof ClassFilterOptions
   */
  instanceId?: UnifiedClassInstanceRefOptional;
  /**
   *
   * @type {UnifiedClassSignupRef}
   * @memberof ClassFilterOptions
   */
  signupId?: UnifiedClassSignupRefOptional;
}

export interface ClassFilterOptions extends ClassFilterOptionsOptional {
  /**
   *
   * @type {boolean}
   * @memberof ClassFilterOptions
   */
  includeAvailability?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassFilterOptions
   */
  includeCancelled?: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassFilterOptions
   */
  startDate?: Date;
  /**
   *
   * @type {string}
   * @memberof ClassFilterOptions
   */
  endDate?: Date;
  /**
   *
   * @type {UnifiedClassTypeRef}
   * @memberof ClassFilterOptions
   */
  typeId?: UnifiedClassTypeRef;
  /**
   *
   * @type {ProgramTypeRef}
   * @memberof ClassFilterOptions
   */
  programId?: ProgramTypeRef;
  /**
   *
   * @type {UnifiedClassInstanceRef}
   * @memberof ClassFilterOptions
   */
  instanceId?: UnifiedClassInstanceRef;
  /**
   *
   * @type {UnifiedClassSignupRef}
   * @memberof ClassFilterOptions
   */
  signupId?: UnifiedClassSignupRef;
}

export interface ClassFilterOptionsTrackedI {
  /**
   *
   * @type {boolean}
   * @memberof ClassFilterOptions
   */
  includeAvailability?: boolean;
  includeAvailabilityIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassFilterOptions
   */
  includeCancelled?: boolean;
  includeCancelledIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassFilterOptions
   */
  startDate?: Date;
  startDateIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassFilterOptions
   */
  endDate?: Date;
  endDateIsSet: boolean;
  /**
   *
   * @type {UnifiedClassTypeRef}
   * @memberof ClassFilterOptions
   */
  typeId?: UnifiedClassTypeRefTrackedI;
  typeIdIsSet: boolean;
  /**
   *
   * @type {ProgramTypeRef}
   * @memberof ClassFilterOptions
   */
  programId?: ProgramTypeRefTrackedI;
  programIdIsSet: boolean;
  /**
   *
   * @type {UnifiedClassInstanceRef}
   * @memberof ClassFilterOptions
   */
  instanceId?: UnifiedClassInstanceRefTrackedI;
  instanceIdIsSet: boolean;
  /**
   *
   * @type {UnifiedClassSignupRef}
   * @memberof ClassFilterOptions
   */
  signupId?: UnifiedClassSignupRefTrackedI;
  signupIdIsSet: boolean;
}

transformDatesMap.set(
  "ClassFilterOptions",
  function (model: ClassFilterOptions) {
    if (typeof model.startDate == "string")
      model.startDate = new Date(model.startDate);
    if (typeof model.endDate == "string")
      model.endDate = new Date(model.endDate);
    const transformDatestypeId = transformDatesMap.get("UnifiedClassTypeRef");
    if (transformDatestypeId && model.typeId) {
      transformDatestypeId(model.typeId);
    }
    const transformDatesprogramId = transformDatesMap.get("ProgramTypeRef");
    if (transformDatesprogramId && model.programId) {
      transformDatesprogramId(model.programId);
    }
    const transformDatesinstanceId = transformDatesMap.get(
      "UnifiedClassInstanceRef",
    );
    if (transformDatesinstanceId && model.instanceId) {
      transformDatesinstanceId(model.instanceId);
    }
    const transformDatessignupId = transformDatesMap.get(
      "UnifiedClassSignupRef",
    );
    if (transformDatessignupId && model.signupId) {
      transformDatessignupId(model.signupId);
    }
  },
);

export type ClassFilterOptionsMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  includeAvailability: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  includeCancelled: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: true
  startDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: true
  endDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  typeId: PropertyMeta<UnifiedClassTypeRefMetaI>;
  //isDate: false
  //isDatetime: false
  programId: PropertyMeta<ProgramTypeRefMetaI>;
  //isDate: false
  //isDatetime: false
  instanceId: PropertyMeta<UnifiedClassInstanceRefMetaI>;
  //isDate: false
  //isDatetime: false
  signupId: PropertyMeta<UnifiedClassSignupRefMetaI>;
}>;

export var ClassFilterOptionsMeta: ClassFilterOptionsMetaI =
  {} as ClassFilterOptionsMetaI;
ClassFilterOptionsMeta = typeMeta("ClassFilterOptions", {
  includeAvailability: propertyMeta(
    "includeAvailability",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  includeCancelled: propertyMeta(
    "includeCancelled",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  startDate: propertyMeta("startDate", false, false, false, MetaTypesBase.Date),
  endDate: propertyMeta("endDate", false, false, false, MetaTypesBase.Date),
  typeId: propertyMeta("typeId", false, false, false, UnifiedClassTypeRefMeta),
  programId: propertyMeta("programId", false, false, false, ProgramTypeRefMeta),
  instanceId: propertyMeta(
    "instanceId",
    false,
    false,
    false,
    UnifiedClassInstanceRefMeta,
  ),
  signupId: propertyMeta(
    "signupId",
    false,
    false,
    false,
    UnifiedClassSignupRefMeta,
  ),
});

const metaI = ClassFilterOptionsMeta;

registerMeta(() => {});

export class ClassFilterOptionsTracked implements ClassFilterOptionsTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  includeAvailability__I?: boolean = undefined;
  includeAvailabilityIsSet: boolean = false;
  set includeAvailability(v: undefined | boolean) {
    if (v !== undefined) {
      this.includeAvailability__I = v;
      this.includeAvailabilityIsSet = true;
    } else {
      this.includeAvailability__I = v || undefined;
      this.includeAvailabilityIsSet = false;
    }
    this.changeTracker = true;
  }
  get includeAvailability() {
    return this.includeAvailability__I;
  }
  includeCancelled__I?: boolean = undefined;
  includeCancelledIsSet: boolean = false;
  set includeCancelled(v: undefined | boolean) {
    if (v !== undefined) {
      this.includeCancelled__I = v;
      this.includeCancelledIsSet = true;
    } else {
      this.includeCancelled__I = v || undefined;
      this.includeCancelledIsSet = false;
    }
    this.changeTracker = true;
  }
  get includeCancelled() {
    return this.includeCancelled__I;
  }
  startDate__I?: Date = undefined;
  startDateIsSet: boolean = false;
  set startDate(v: undefined | Date) {
    if (v !== undefined) {
      this.startDate__I = v;
      this.startDateIsSet = true;
    } else {
      this.startDate__I = v || undefined;
      this.startDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get startDate() {
    return this.startDate__I;
  }
  endDate__I?: Date = undefined;
  endDateIsSet: boolean = false;
  set endDate(v: undefined | Date) {
    if (v !== undefined) {
      this.endDate__I = v;
      this.endDateIsSet = true;
    } else {
      this.endDate__I = v || undefined;
      this.endDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get endDate() {
    return this.endDate__I;
  }
  typeId__I?: UnifiedClassTypeRefTracked = undefined;
  typeIdIsSet: boolean = false;
  set typeId(v: undefined | UnifiedClassTypeRefTracked) {
    if (v !== undefined) {
      this.typeId__I = v;
      this.typeIdIsSet = true;
    } else {
      this.typeId__I = v || undefined;
      this.typeIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get typeId() {
    return this.typeId__I;
  }
  programId__I?: ProgramTypeRefTracked = undefined;
  programIdIsSet: boolean = false;
  set programId(v: undefined | ProgramTypeRefTracked) {
    if (v !== undefined) {
      this.programId__I = v;
      this.programIdIsSet = true;
    } else {
      this.programId__I = v || undefined;
      this.programIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get programId() {
    return this.programId__I;
  }
  instanceId__I?: UnifiedClassInstanceRefTracked = undefined;
  instanceIdIsSet: boolean = false;
  set instanceId(v: undefined | UnifiedClassInstanceRefTracked) {
    if (v !== undefined) {
      this.instanceId__I = v;
      this.instanceIdIsSet = true;
    } else {
      this.instanceId__I = v || undefined;
      this.instanceIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get instanceId() {
    return this.instanceId__I;
  }
  signupId__I?: UnifiedClassSignupRefTracked = undefined;
  signupIdIsSet: boolean = false;
  set signupId(v: undefined | UnifiedClassSignupRefTracked) {
    if (v !== undefined) {
      this.signupId__I = v;
      this.signupIdIsSet = true;
    } else {
      this.signupId__I = v || undefined;
      this.signupIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get signupId() {
    return this.signupId__I;
  }
  constructor(config?: ClassFilterOptionsOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.typeId?.setIds();

    this.programId?.setIds();

    this.instanceId?.setIds();

    this.signupId?.setIds();
  }
  assignFrom(
    config: ClassFilterOptionsOptional,
    options?: AssignOptions,
  ): ClassFilterOptionsTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.includeAvailability &&
      this.includeAvailabilityApplyFilter(optionsRequired.filter)
    ) {
      this.includeAvailability = config.includeAvailability;
      if (optionsRequired.unassign) this.includeAvailabilityIsSet = false;
      else this.includeAvailabilityIsSet = true;
    }
    if (
      config.includeCancelled &&
      this.includeCancelledApplyFilter(optionsRequired.filter)
    ) {
      this.includeCancelled = config.includeCancelled;
      if (optionsRequired.unassign) this.includeCancelledIsSet = false;
      else this.includeCancelledIsSet = true;
    }
    if (config.startDate && this.startDateApplyFilter(optionsRequired.filter)) {
      this.startDate = config.startDate;
      if (optionsRequired.unassign) this.startDateIsSet = false;
      else this.startDateIsSet = true;
    }
    if (config.endDate && this.endDateApplyFilter(optionsRequired.filter)) {
      this.endDate = config.endDate;
      if (optionsRequired.unassign) this.endDateIsSet = false;
      else this.endDateIsSet = true;
    }
    if (config.typeId && this.typeIdApplyFilter(optionsRequired.filter)) {
      this.typeId = new UnifiedClassTypeRefTracked(config.typeId, options);
      if (optionsRequired.unassign) this.typeIdIsSet = false;
      else this.typeIdIsSet = true;
    }
    if (config.programId && this.programIdApplyFilter(optionsRequired.filter)) {
      this.programId = new ProgramTypeRefTracked(config.programId, options);
      if (optionsRequired.unassign) this.programIdIsSet = false;
      else this.programIdIsSet = true;
    }
    if (
      config.instanceId &&
      this.instanceIdApplyFilter(optionsRequired.filter)
    ) {
      this.instanceId = new UnifiedClassInstanceRefTracked(
        config.instanceId,
        options,
      );
      if (optionsRequired.unassign) this.instanceIdIsSet = false;
      else this.instanceIdIsSet = true;
    }
    if (config.signupId && this.signupIdApplyFilter(optionsRequired.filter)) {
      this.signupId = new UnifiedClassSignupRefTracked(
        config.signupId,
        options,
      );
      if (optionsRequired.unassign) this.signupIdIsSet = false;
      else this.signupIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): ClassFilterOptionsTrackedI {
    const cloned = {} as ClassFilterOptionsTrackedI;
    if (
      this.includeAvailabilityIsSetDeep() &&
      this.includeAvailabilityApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.includeAvailabilityIsSet = true;
      cloned.includeAvailability = this.includeAvailability;
    } else {
      //cloned.includeAvailabilityIsSet = false
    }
    if (
      this.includeCancelledIsSetDeep() &&
      this.includeCancelledApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.includeCancelledIsSet = true;
      cloned.includeCancelled = this.includeCancelled;
    } else {
      //cloned.includeCancelledIsSet = false
    }
    if (
      this.startDateIsSetDeep() &&
      this.startDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.startDateIsSet = true;
      cloned.startDate = this.startDate;
    } else {
      //cloned.startDateIsSet = false
    }
    if (
      this.endDateIsSetDeep() &&
      this.endDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.endDateIsSet = true;
      cloned.endDate = this.endDate;
    } else {
      //cloned.endDateIsSet = false
    }
    if (
      this.typeIdIsSetDeep() &&
      this.typeIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.typeIdIsSet = true;
      cloned.typeId = this.typeId?.removeUnset(filter);
    } else {
      //cloned.typeIdIsSet = false
    }
    if (
      this.programIdIsSetDeep() &&
      this.programIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.programIdIsSet = true;
      cloned.programId = this.programId?.removeUnset(filter);
    } else {
      //cloned.programIdIsSet = false
    }
    if (
      this.instanceIdIsSetDeep() &&
      this.instanceIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.instanceIdIsSet = true;
      cloned.instanceId = this.instanceId?.removeUnset(filter);
    } else {
      //cloned.instanceIdIsSet = false
    }
    if (
      this.signupIdIsSetDeep() &&
      this.signupIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.signupIdIsSet = true;
      cloned.signupId = this.signupId?.removeUnset(filter);
    } else {
      //cloned.signupIdIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): ClassFilterOptionsTrackedI {
    if (!this.includeAvailabilityApplyFilter(filter))
      this.includeAvailabilityIsSet = false;

    if (!this.includeCancelledApplyFilter(filter))
      this.includeCancelledIsSet = false;

    if (!this.startDateApplyFilter(filter)) this.startDateIsSet = false;

    if (!this.endDateApplyFilter(filter)) this.endDateIsSet = false;

    if (!this.typeIdApplyFilter(filter)) this.typeIdIsSet = false;
    this.typeId?.unassignAll(filter);

    if (!this.programIdApplyFilter(filter)) this.programIdIsSet = false;
    this.programId?.unassignAll(filter);

    if (!this.instanceIdApplyFilter(filter)) this.instanceIdIsSet = false;
    this.instanceId?.unassignAll(filter);

    if (!this.signupIdApplyFilter(filter)) this.signupIdIsSet = false;
    this.signupId?.unassignAll(filter);

    return this;
  }
  includeAvailabilityApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassFilterOptionsMeta.includeAvailability,
      ClassFilterOptionsMeta,
      this.includeAvailability,
      this,
    );
  }
  includeAvailabilityIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.includeAvailabilityIsSet &&
      this.includeAvailabilityApplyFilter(filter)
    )
      return true;

    return false;
  }
  includeCancelledApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassFilterOptionsMeta.includeCancelled,
      ClassFilterOptionsMeta,
      this.includeCancelled,
      this,
    );
  }
  includeCancelledIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.includeCancelledIsSet && this.includeCancelledApplyFilter(filter))
      return true;

    return false;
  }
  startDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassFilterOptionsMeta.startDate,
      ClassFilterOptionsMeta,
      this.startDate,
      this,
    );
  }
  startDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.startDateIsSet && this.startDateApplyFilter(filter)) return true;

    return false;
  }
  endDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassFilterOptionsMeta.endDate,
      ClassFilterOptionsMeta,
      this.endDate,
      this,
    );
  }
  endDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.endDateIsSet && this.endDateApplyFilter(filter)) return true;

    return false;
  }
  typeIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassFilterOptionsMeta.typeId,
      ClassFilterOptionsMeta,
      this.typeId,
      this,
    );
  }
  typeIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.typeIdIsSet && this.typeIdApplyFilter(filter)) return true;
    return this.typeId?.anySet(filter) == true;

    return false;
  }
  programIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassFilterOptionsMeta.programId,
      ClassFilterOptionsMeta,
      this.programId,
      this,
    );
  }
  programIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.programIdIsSet && this.programIdApplyFilter(filter)) return true;
    return this.programId?.anySet(filter) == true;

    return false;
  }
  instanceIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassFilterOptionsMeta.instanceId,
      ClassFilterOptionsMeta,
      this.instanceId,
      this,
    );
  }
  instanceIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.instanceIdIsSet && this.instanceIdApplyFilter(filter)) return true;
    return this.instanceId?.anySet(filter) == true;

    return false;
  }
  signupIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassFilterOptionsMeta.signupId,
      ClassFilterOptionsMeta,
      this.signupId,
      this,
    );
  }
  signupIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.signupIdIsSet && this.signupIdApplyFilter(filter)) return true;
    return this.signupId?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.includeAvailabilityIsSetDeep(filter)) return true;
    if (this.includeCancelledIsSetDeep(filter)) return true;
    if (this.startDateIsSetDeep(filter)) return true;
    if (this.endDateIsSetDeep(filter)) return true;
    if (this.typeIdIsSetDeep(filter)) return true;
    if (this.programIdIsSetDeep(filter)) return true;
    if (this.instanceIdIsSetDeep(filter)) return true;
    if (this.signupIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
